import React from 'react';

import { useLocale } from '@adsk/alloy-react-helpers';
import ProgressRing from '@adsk/alloy-react-progress-ring';

export const LoadingSuggestion = ({
  searchValue,
}: {
  searchValue?: string;
}) => {
  const { T } = useLocale(({ locale }) => require(`../i18n/${locale}.json`));

  if (!searchValue) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '0 16px 4px',
        height: 56,
      }}
    >
      <ProgressRing style={{ marginLeft: 3, marginRight: 14 }} />
      <span>{T.translate('LOADING_SEARCH', { search: searchValue })}</span>
    </div>
  );
};
